import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetDynamicFormColumnListByTableId } from '../../store/NTX/FlexValue/Form/FormColumnSlice';

const useGetColumnByTableId = tableId => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (tableId) {
      dispatch(GetDynamicFormColumnListByTableId(tableId));
    }
  }, [dispatch, tableId]);
  const { FormColumnByTableIdList, loading2, error2 } = useSelector(state => state.FormColumns);

  return { FormColumnByTableIdList, loading: loading2, error: error2 };
};

export default useGetColumnByTableId;
